const mediaQueryMax = (size: string) =>
  `@media only screen and (max-width: ${size})`;

export const mediaQueryMaxMedium = mediaQueryMax("767px");
